import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { MessageCircle, Users, TrendingUp, Zap } from "lucide-react";

const DiscordCommunity = () => {
  const features = [
    {
      icon: Users,
      title: "Active Trading Community",
      description: "Connect with passionate traders sharing real-time insights, market analysis, and winning strategies"
    },
    {
      icon: TrendingUp,
      title: "Expert Guidance",
      description: "Learn from experienced traders and get your questions answered by our team of professionals"
    },
    {
      icon: Zap,
      title: "Live Updates & Alerts",
      description: "Get instant notifications about market opportunities, new signals, and platform updates"
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-opal opacity-10" />
      <div className="container px-4 relative z-10">
        <div className="text-center mb-12 space-y-4">
          <div className="flex justify-center mb-6">
            <div className="p-6 bg-gradient-primary rounded-full animate-glow">
              <MessageCircle className="w-16 h-16" />
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold">
            Join Our <span className="bg-gradient-primary bg-clip-text text-transparent">Active Trading Community</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Connect with a growing community of professional traders. Share strategies, get instant support, and stay ahead of market trends — completely free.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {features.map((feature, index) => (
            <Card key={index} className="p-6 bg-card/40 backdrop-blur-xl border-border hover:border-primary/50 transition-all hover:scale-105 text-center space-y-4 group">
              <div className="flex justify-center">
                <div className="p-3 bg-gradient-primary rounded-lg group-hover:shadow-glow-primary transition-all">
                  <feature.icon className="w-6 h-6" />
                </div>
              </div>
              <h3 className="text-lg font-semibold">{feature.title}</h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </Card>
          ))}
        </div>

        <div className="flex justify-center">
          <Button 
            size="lg" 
            className="text-lg px-12 py-6 h-auto bg-gradient-primary hover:shadow-glow-primary group"
            asChild
          >
            <a 
              href="https://discord.gg/fxXR3h8b9k"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3"
            >
              <MessageCircle className="w-6 h-6 group-hover:scale-110 transition-transform" />
              Join Discord Community — Free
            </a>
          </Button>
        </div>
        
        <div className="text-center mt-8">
          <p className="text-sm text-muted-foreground">
            Growing community • 24/7 active support • Free forever
          </p>
        </div>
      </div>
    </section>
  );
};

export default DiscordCommunity;
